export const styles = {
  expandableTable: {
    borderSpacing: 0,
  },
  tableDetailsCell: {
    '&.table-cell.collapsible-row-cell-details': {
      paddingTop: 0,
      paddingBottom: 3,
      paddingLeft: `5px`,
    },
  },
  expandCell: (theme) => ({
    minWidth: 'auto',
    maxWidth: 36,
    padding: theme.spacing(0, 1),
    '.MuiTableRow-root &:first-of-type': {
      padding: theme.spacing(0, '3px'),
    },
  }),
  rowEven: ({ palette }) => ({
    '&.table-row': {
      backgroundColor: `${palette.common.white}`,
    },
  }),
  rowOdd: ({ palette }) => ({
    '&.table-row': {
      backgroundColor: `${palette.accentFade.main}`,
    },
  }),
};
